/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { configureAmplify } from './app/core/config/amplify.config';
import { environment } from './environments/environment';
import { tenant } from './tenants/tenant';

function logAppConfig(): void {
  const env = environment as any;
  const chatCfg = tenant.chatConfig;
  const chatEnv: 'uat' | 'prod' = env.envName === 'prod' ? 'prod' : 'uat';

  const lines = [
    `Tenant        : ${tenant.tenandId} (${tenant.brandName})`,
    `Environment   : ${chatEnv} | production=${env.production}`,
    `API URL       : ${env.apiUrl}`,
    `Chat bundle   : ${chatCfg?.bundleFile ?? '—'}`,
    `Chat element  : <${chatCfg?.elementTag ?? '—'}>`,
    `Chat env      : ${chatEnv}  →  ${chatCfg?.envConfig?.[chatEnv]?.apiEndpoint ?? env.apiUrl}`,
    `Cognito pool  : ${env.amplify?.userPoolId ?? '—'}`,
  ];

  console.groupCollapsed(
    `[NEXA] App Config — ${tenant.tenandId.toUpperCase()} / ${chatEnv.toUpperCase()}`
  );
  lines.forEach(l => console.log(l));
  console.groupEnd();
}

function setFavicon(): void {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (link) {
    link.href = tenant.favicon;
  }
}

logAppConfig();
setFavicon();
configureAmplify();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
